import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useLang } from "../lib/lang";
import { Calendar, MapPin } from "lucide-react";

export default function EventsPage() {
  const { t, tri } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/events").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App" data-testid="events-page">
      <Header />
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="border-b border-slate-200 pb-6 mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-red-600 font-semibold mb-2">Briefings</div>
          <h1 className="font-display text-5xl sm:text-6xl text-slate-900">{t("nav_events")}</h1>
        </div>

        {items.length === 0 ? (
          <div className="text-slate-500 py-12" data-testid="events-empty">{t("no_data")}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {items.map((e, i) => (
              <div key={e.id} className="kn-card bg-white border border-slate-200" data-testid={`event-item-${i}`}>
                {e.image_url && (
                  <div className="aspect-[16/9] bg-slate-100 overflow-hidden">
                    <img src={e.image_url} alt="" className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-slate-600 mb-3">
                    <span className="flex items-center gap-1 text-red-600 font-semibold">
                      <Calendar className="w-3 h-3" />
                      {new Date(e.event_date).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                    {e.location && (
                      <span className="flex items-center gap-1">
                        <MapPin className="w-3 h-3" /> {e.location}
                      </span>
                    )}
                  </div>
                  <h3 className="font-display text-3xl text-slate-900 mb-3 leading-tight">
                    {tri(e.title)}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{tri(e.description)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
